import { useNavigate } from "react-router-dom";
import { TitlelessCard, ODataGrid, Breakpoints, ResponsiveGridColumn } from "../../../../components";
import CTEyeService from "../../../../services/CTEyeService";
import { useDebouncedFilter } from '../../hooks';
import { formatDateTime } from "../../../../app/dateHelpers";
import { deriveAlertLevel } from "../../helper";
import { DashboardSectionHeader } from "./DashboardSectionHeader";
import { BadgeVariant, DotBadge } from "../DotBadge";

const getRecentInspections = async (oDataQuery: string) => {
  const expandedQuery = `$expand=CTEyeClient,Inspection&$orderby=endDate desc&${oDataQuery}`;
  return await new CTEyeService().getRecentUploadSessionsOData(expandedQuery);
};

export function RecentInspectionsGrid() {
  const navigate = useNavigate();
  const inspectionSearch = useDebouncedFilter();

  const filter = inspectionSearch.filter
    ? { logic: "or" as const, filters: [
        { field: "ctEyeClient/description", operator: "contains", value: inspectionSearch.filter },
        { field: "inspection/reference", operator: "contains", value: inspectionSearch.filter },
      ]}
    : undefined;

  return (
    <>
      <DashboardSectionHeader
        title="Recent Imported Inspections Per Agent"
        right={
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search agent or inspection..."
            onChange={inspectionSearch.onChange}
            style={{ width: 220 }}
          />
        }
      />
      <TitlelessCard className="p-0" bodyClassName="p-0">
        <ODataGrid
          getData={getRecentInspections}
          pageSize={5}
          pageable={true}
          filterable={false}
          filter={filter}
          onRowClick={(e) =>
            navigate(`/cteye/clients/${e.dataItem.ctEyeClientId}/inspections/${e.dataItem.inspectionId}`)
          }
        >
          <ResponsiveGridColumn title="Agent" field="ctEyeClient.description" sortable={true} filterable={true} />
          <ResponsiveGridColumn
            title="Alert Level"
            field="inspection.alertCount"
            sortable={false}
            filterable={false}
            cell={(props) => {
              const level = deriveAlertLevel(props.dataItem.inspection);
              return (
                <td>
                  <DotBadge variant={level.toLowerCase() as BadgeVariant} />
                </td>
              );
            }}
          />
          <ResponsiveGridColumn 
            title="Inspection" 
            field="inspection.reference" 
            sortable={false} 
            filterable={false} 
            breakpoint={Breakpoints.md} 
          />
          <ResponsiveGridColumn
            title="Completed"
            field="endDate"
            sortable={true}
            filterable={false}
            breakpoint={Breakpoints.xl}
            cell={(props) => (
              <td className="text-secondary small">
                {props.dataItem.endDate ? formatDateTime(new Date(props.dataItem.endDate)) : "—"}
              </td>
            )}
          />
        </ODataGrid>
      </TitlelessCard>
    </>
  );
}